import script from "./MediaList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaList.vue?vue&type=script&setup=true&lang=ts"

import "./MediaList.vue?vue&type=style&index=0&id=056f052b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056f052b"]])

export default __exports__